import React from "react";
import { TimePicker } from "@fluentui/react";

interface IProps {
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  value?: Date;
  onSelectTime: (date: Date) => void;
}

export default function FluentUiTimePicker({
  label,
  placeholder,
  required,
  disabled,
  value,
  onSelectTime,
}: IProps) {
  return (
    <TimePicker
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      useHour12={false}
      increments={5}
      value={value}
      allowFreeform
      onChange={(event, time: Date) => onSelectTime(time)}
    />
  );
}

FluentUiTimePicker.defaultProps = {
  label: "",
  placeholder: "",
  required: false,
  disabled: false,
};
